import { Box, Button, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { fetchConfigEnded, getConfig } from "../../modules/configuration";
import { fetchElencoProntoSoccorsoEnded, getElencoProntoSoccorso } from "../../modules/prontoSoccorso";
import { LOADING_CONFIG_ERROR, LOADING_PS_ERROR, RETRY } from "../../modules/language";
import { LoadingSpinner } from "../shared";
import { getMessageString } from "../../utility";

export const ErrorPage = injectIntl(({ intl, onRetry }) => {
  const config = useSelector(getConfig);
  const configEnded = useSelector(fetchConfigEnded);
  const elencoPs = useSelector(getElencoProntoSoccorso);
  const elencoPsEnded = useSelector(fetchElencoProntoSoccorsoEnded);

  return (
    <Stack sx={{ height: "100%" }}>
      <Box className="errorPage">
        {config == null && <Typography>{getMessageString(intl, LOADING_CONFIG_ERROR)}</Typography>}
        {elencoPs?.length === 0 && <Typography>{getMessageString(intl, LOADING_PS_ERROR)}</Typography>}
        <Button onClick={onRetry}>{getMessageString(intl, RETRY)}</Button>
      </Box>
      <LoadingSpinner loading={!configEnded || !elencoPsEnded} />
    </Stack>
  );
});
